import { render, staticRenderFns } from "./CourseContentDetail.vue?vue&type=template&id=f0c1baa6"
import script from "./CourseContentDetail.vue?vue&type=script&lang=js"
export * from "./CourseContentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CourseDescription: require('/vercel/path0/components/CourseDescription.vue').default})
